import ChangeAdminStatusDialog from './changeAdminStatusDialog.container';

export default ChangeAdminStatusDialog;
